import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { getPriceLadder, getPriceLadderChart2 } from 'gqlQueries/priceLadder';
import { priceLadderAttributeLevelChart2Parser } from 'parser/priceLadderParser';
import { getPriceCurveChart2 } from 'gqlQueries/priceCurve';
import { fetchPriceAlertData } from 'gqlQueries/priceAlert';
import { priceAlertDataParser } from 'parser/priceAlertDataParser';
const errorMessage: string = 'Something went wrong!';

function useFetchPriceAlert() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const [count, setCount] = useState(0);
    const variablesRef = useRef<any>({});
    const { appConfig } = useContext(UserContext);

    const [fetchPriceAlert, { data: landscapeData, loading: landscapeDataLoading, error: landscapeDataError }] =
        useLazyQuery(fetchPriceAlertData, {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { priceAlertTabularData } = payload;
            if (priceAlertTabularData && 'data' in priceAlertTabularData) {
                if (priceAlertTabularData.data?.length === 0) throw 'No Data';
                const parsedTableData = priceAlertDataParser(
                    priceAlertTabularData?.data || [],
                    appConfig,
                    data,
                    variablesRef.current?.kpiName,
                );

                if (variablesRef?.current?.offset > 0 && data) {
                    setData({ tableData: [...data?.tableData, ...parsedTableData] });
                } else {
                    setData({ tableData: parsedTableData });
                }
                setCount(priceAlertTabularData?.count || 0);
            }
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData(null);
        setCount(0);
        setLoading(false);
        setError(error);
    }

    function emptyData() {
        setData(null);
        setCount(0);
    }

    return {
        loading,
        error,
        count,
        data,
        emptyData,
        fetchPriceAlertData: (variables: any) => {
            variablesRef.current = variables.variables;
            //only set data to null if function is being called outside/without infinite scroll
            //if offset is equal to default offset, it means request is coming without infinite scroll
            if (variables.variables?.offset === 0) {
                setData(null);
            }
            setLoading(true);
            setError(null);
            fetchPriceAlert(variables);
            // onFetchComplete(variables);
        },
    };
}

export { useFetchPriceAlert };
